import React from 'react';
import Slider from 'react-slick';
import Client_1 from '../../../assets/images/home_page_3/adv-slider/01.png';

const clientLogos = [
    { id: 1, src: Client_1, alt: 'Client 1' },
    { id: 2, src: Client_1, alt: 'Client 1' },
    { id: 3, src: Client_1, alt: 'Client 1' },
    { id: 4, src: Client_1, alt: 'Client 1' },
    { id: 5, src: Client_1, alt: 'Client 1' },
    { id: 6, src: Client_1, alt: 'Client 1' },
];

const ClientSliderSettings = {
    slidesToShow: 4,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
    ],
};

const Client = () => {
    return (
        <div id="client-slider" className="client-slider-main-block">
            <Slider className="slider client-slider-center-mode" {...ClientSliderSettings}>
                {clientLogos.map(client => (
                    <div key={client.id} className="client-slider-img">
                        <img
                            src={client.src}
                            className="img-fluid"
                            alt={client.alt}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default Client;